export default __webpack_public_path__ + "static/media/propsPanelSearch.08068a55.svg";